<ng-container *transloco="let t">
  <div class="modal-header">
    <button (click)="activeModal.dismiss(null)" aria-label="Close" class="btn-close-icon" tabindex="-1">
      <i class="material-symbols-rounded">close</i>
    </button>
  </div>
  <div class="modal-body">
    <h2>{{ t(title) }}</h2>
    <div class="selected-childs">
      <span class="selected-text">
        {{ t('evidence/selected') }} {{ childAttendanceOverview || children?.length === 1 ? t('shared/child') : t('shared/children') }}:
        <ng-container *ngIf="!showChildrenNames">{{
          childAttendanceOverview || children?.length === 1 ? 1 : children?.length
        }}</ng-container>
      </span>
      <ng-container *ngIf="showChildrenNames">
        <div class="child-chip" *ngFor="let child of children">{{ child.lastName }} {{ child.firstName }}</div>
      </ng-container>
    </div>

    <div class="btn-group absence attendance-type" role="attendance-type" aria-label="attendance-type radio toggle button">
      <input
        type="radio"
        class="btn-check"
        name="attendanceType"
        id="present"
        [value]="attendanceTypeEnum.PRESENT_TYPE"
        [(ngModel)]="attendanceType"
        (ngModelChange)="onChangeAttendanceType()"
      />
      <label class="btn btn-outline-primary border-end-0" for="present">
        {{ t('evidence/present') }}
      </label>

      <input
        type="radio"
        class="btn-check"
        name="attendanceType"
        id="notPresent"
        [value]="attendanceTypeEnum.MISSING_TYPE"
        [(ngModel)]="attendanceType"
        (ngModelChange)="onChangeAttendanceType()"
      />
      <label class="btn btn-outline-primary border-end-0" for="notPresent">
        {{ t('evidence/missing') }}
      </label>

      <input
        type="radio"
        class="btn-check"
        name="attendanceType"
        id="absent"
        [value]="attendanceTypeEnum.ABSENT_TYPE"
        [(ngModel)]="attendanceType"
        (ngModelChange)="onChangeAttendanceType()"
      />
      <label class="btn btn-outline-primary border-start-0" for="absent">
        {{ t('evidence/absent') }}
      </label>
    </div>

    <div
      *ngIf="attendanceType === attendanceTypeEnum.PRESENT_TYPE || attendanceType === attendanceTypeEnum.MISSING_TYPE"
      class="time-container"
    >
      <!-- Hours inputs -->
      <ng-container *ngIf="dateInputType === 'hours'">
        <div>
          <label for="arrival">{{ t('evidence/arrival') }}:</label>
          <div class="input-group" [ngClass]="{ 'input-disabled': attendanceType === attendanceTypeEnum.MISSING_TYPE }">
            <input
              id="arrival"
              class="form-control"
              [(ngModel)]="arrival"
              [placeholder]="t('evidence/enterTime')"
              [disabled]="attendanceType === attendanceTypeEnum.MISSING_TYPE"
            />
            <div class="input-group-append" ngbDropdown container="body" placement="bottom-end" dropdownClass="time-menu-container">
              <button class="btn" type="button" ngbDropdownToggle>
                <i [class]="icons.clock"></i>
              </button>
              <div ngbDropdownMenu class="time-menu">
                <ul>
                  <li *ngFor="let i of timeList" class="dropdown-item" (click)="selectArrivalTime(i)">{{ i }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div>
          <label for="departure">{{ t('evidence/departure') }}:</label>
          <div class="input-group" [ngClass]="{ 'input-disabled': attendanceType === attendanceTypeEnum.MISSING_TYPE }">
            <input
              id="departure"
              class="form-control"
              [(ngModel)]="departure"
              [placeholder]="t('evidence/enterTime')"
              [disabled]="attendanceType === attendanceTypeEnum.MISSING_TYPE"
            />
            <div class="input-group-append" ngbDropdown container="body" placement="bottom-end" dropdownClass="time-menu-container">
              <button class="btn" type="button" ngbDropdownToggle>
                <i [class]="icons.clock"></i>
              </button>
              <div ngbDropdownMenu class="time-menu">
                <ul>
                  <li *ngFor="let i of timeList" class="dropdown-item" (click)="selectDepartureTime(i)">{{ i }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="dateInputType === 'days'">
        <div>
          <label for="dateFrom">{{ t('shared/date') }} {{ t('shared/from') }}:</label>
          <div class="input-group">
            <input
              id="dateFrom"
              class="form-control"
              [(ngModel)]="dateFrom"
              ngbDatepicker
              [readOnly]="true"
              #dp="ngbDatepicker"
              (click)="dp.toggle()"
            />
            <div class="input-group-append">
              <button class="btn" (click)="dp.toggle()" type="button">
                <img src="assets/img/calendar.svg" alt="calendar" />
              </button>
            </div>
          </div>
        </div>

        <div>
          <label for="dateTo">{{ t('shared/date') }} {{ t('shared/to') }}:</label>
          <div class="input-group">
            <input
              id="dateTo"
              class="form-control"
              [(ngModel)]="dateTo"
              ngbDatepicker
              [readOnly]="true"
              #dp1="ngbDatepicker"
              (click)="dp1.toggle()"
            />
            <div class="input-group-append">
              <button class="btn" (click)="dp1.toggle()" type="button">
                <img src="assets/img/calendar.svg" alt="calendar" />
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="attendanceType === attendanceTypeEnum.ABSENT_TYPE">
      <!-- Absence day part -->
      <div class="btn-group absence" role="group" aria-label="absence radio toggle button group">
        <input type="radio" class="btn-check" name="absence" id="morning" [value]="absenceEnum.AbsentMorning" [(ngModel)]="absence" />
        <label class="btn btn-outline-primary border-end-0" for="morning">
          <img src="assets/img/attendance/{{ absenceEnum.AbsentMorning }}.svg" alt="absence morning" />
          {{ t('evidence/morning') }}
        </label>

        <input type="radio" class="btn-check" name="absence" id="afternoon" [value]="absenceEnum.AbsentAfternoon" [(ngModel)]="absence" />
        <label class="btn btn-outline-primary" for="afternoon">
          <img src="assets/img/attendance/{{ absenceEnum.AbsentAfternoon }}.svg" alt="absence after" />
          {{ t('evidence/afternoon') }}
        </label>

        <input type="radio" class="btn-check" name="absence" id="all-day" [value]="absenceEnum.Absent" [(ngModel)]="absence" />
        <label class="btn btn-outline-primary border-start-0" for="all-day">
          <img src="assets/img/attendance/{{ absenceEnum.Absent }}.svg" alt="absence" />
          {{ t('evidence/allDay') }}
        </label>
      </div>
      <!-- Absence reason -->
      <div class="absence-reason">
        <input
          type="radio"
          class="btn-check"
          name="absenceReason"
          id="doctor"
          [value]="absenceReasonEnum.Doctor"
          [(ngModel)]="absenceReason"
        />
        <label class="reason-group" for="doctor">
          <div class="img-wrapper">
            <img src="assets/img/attendance/absenceReason/doctor.svg" alt="doctor" />
          </div>
          <span>{{ t('evidence/doctor') }}</span>
        </label>

        <input
          type="radio"
          class="btn-check"
          name="absenceReason"
          id="illness"
          [value]="absenceReasonEnum.Sickness"
          [(ngModel)]="absenceReason"
        />
        <label class="reason-group" for="illness">
          <div class="img-wrapper">
            <img src="assets/img/attendance/absenceReason/illness.svg" alt="illness" />
          </div>
          {{ t('evidence/illness') }}
        </label>

        <input
          type="radio"
          class="btn-check"
          name="absenceReason"
          id="holiday"
          [value]="absenceReasonEnum.Vacation"
          [(ngModel)]="absenceReason"
        />
        <label class="reason-group" for="holiday">
          <div class="img-wrapper">
            <img src="assets/img/attendance/absenceReason/holiday.svg" alt="holiday" />
          </div>
          {{ t('evidence/holiday') }}
        </label>

        <input
          type="radio"
          class="btn-check"
          name="absenceReason"
          id="family"
          [value]="absenceReasonEnum.FamilyReason"
          [(ngModel)]="absenceReason"
        />
        <label class="reason-group" for="family">
          <div class="img-wrapper">
            <img src="assets/img/attendance/absenceReason/family.svg" alt="family" />
          </div>
          {{ t('evidence/family') }}
        </label>

        <input
          type="radio"
          class="btn-check"
          name="absenceReason"
          id="other"
          [value]="absenceReasonEnum.Other"
          [(ngModel)]="absenceReason"
        />
        <label class="reason-group" for="other">
          <div class="img-wrapper">
            <img src="assets/img/attendance/absenceReason/other.svg" alt="other" />
          </div>
          {{ t('evidence/other') }}
        </label>
      </div>
    </ng-container>

    <div *ngIf="attendanceType === attendanceTypeEnum.MISSING_TYPE" class="form-check exclude-from-export">
      <input class="form-check-input" type="checkbox" id="excludeFromExport" [(ngModel)]="excludeFromExport" />
      <label class="form-check-label" for="excludeFromExport"
        ><strong>{{ t('evidence/excludeFromExport') }} – </strong>{{ t('evidence/excludeFromExportDetails') }}</label
      >
    </div>
  </div>
  <div class="modal-footer d-flex align-items-center justify-content-center">
    <button (click)="activeModal.close(null)" class="btn btn-lg btn-outline-primary me-4" tabindex="-1">{{ t('child/cancel') }}</button>
    <button
      (click)="submitButton()"
      class="btn btn-lg btn-primary"
      [disabled]="attendanceType === attendanceTypeEnum.ABSENT_TYPE && (!absence || !absenceReason)"
    >
      {{ t('shared/edit') }}
    </button>
  </div>
</ng-container>
